import { createContext, useContext } from 'react';

/* Nom de section porté par la ligne d'onglets (grammaire d'écran, point 1).

   Un hub encadré affichait son titre sur une ligne à lui, au-dessus des
   onglets : un étage de plus avant la première donnée, et un titre qui
   répétait l'entrée de menu déjà surlignée dans le panneau.

   Plutôt que de reprendre chaque hub un par un, c'est le GABARIT qui décide :
   <PageShell framed> repère un <Tabs> parmi ses enfants et lui passe son
   titre par ce contexte. Un hub SANS onglets garde son en-tête — sinon son
   titre disparaîtrait.

   Une sous-page montée en `embedded` remet le contexte à null : son propre
   <Tabs>, s'il en a un, n'hérite pas du titre du hub qui l'accueille. */
export const SectionLeadContext = createContext(null);
export const useSectionLead = () => useContext(SectionLeadContext);
